import React, { Component } from 'react';
import { Toast, ActivityIndicator } from 'antd-mobile';
import axios from 'axios';
import './FilePreview.less';
import Util from 'utils';
// 导入ReactPdf组件用于PDF预览
import ReactPdf from 'react-pdf-js';

class FilePreviewView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUrl: '',
      fileType: '',
      fileName: '',
      loading: true,
      error: null,
      iframeLoading: true, // 跟踪iframe加载状态
      page: 1, // 当前页码 - ReactPdf使用
      total: 1 // 总页数 - ReactPdf使用
    };
    this.iframeRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    const { url } = Util.decodeQuery(this.props.location.search);
    const fileType = this.getFileTypeFromUrl(url);
    const fileName = this.getFileNameFromUrl(url);

    if (!url) {
      this.setState({
        loading: false,
        error: '文件链接不能为空'
      });
      Toast.fail('文件链接不能为空', 2);
      return;
    }

    this.setState({
      fileUrl: url,
      fileType,
      fileName,
      loading: false
    });
  }

  // 新增：处理iframe加载完成
  handleIframeLoad = () => {
    console.log('iframe 加载完成');
    this.setState({ iframeLoading: false });
    // 可以在这里添加加载完成后的逻辑（如隐藏加载动画）
  };

  // 新增：处理iframe加载错误
  handleIframeError = () => {
    console.error('iframe 加载失败');
    this.setState({
      iframeLoading: false,
      error: '文件加载失败，请重试'
    });
    Toast.fail('文件加载失败', 2);
  };

  /**
   * 上一页 - ReactPdf使用
   */
  prevPage = () => {
    const { page } = this.state;
    if (page > 1) {
      this.setState({ page: page - 1 });
    }
  };

  /**
   * 下一页 - ReactPdf使用
   */
  nextPage = () => {
    const { page, total } = this.state;
    if (page < total) {
      this.setState({ page: page + 1 });
    }
  };

  /**
   * PDF文档加载完成回调 - ReactPdf使用
   * @param {number} pages - 总页数
   */
  onDocumentComplete = (pages) => {
    this.setState({ total: pages });
  };

  getFileTypeFromUrl(url) {
    if (!url) return '';
    const extension = url.split('.').pop().toLowerCase();
    return extension;
  }

  getFileNameFromUrl(url) {
    if (!url) return '';
    const parts = url.split('/');
    return parts[parts.length - 1];
  }

  renderPreview() {
    const { fileUrl, fileType, loading, error, iframeLoading, page, total } = this.state;

    if (loading) {
      return (
        <div className="loading-container">
          <ActivityIndicator text="加载中..." />
        </div>
      );
    }

    if (error) {
      return <div className="error-message">{error}</div>;
    }

    // 通用的iframe加载状态显示
    const renderIframeWithLoading = (iframeProps) => (
      <div className="iframe-container">
        {iframeLoading && (
          <div className="iframe-loading">
            <ActivityIndicator text="文档加载中..." />
          </div>
        )}
        <iframe
          {...iframeProps}
          ref={this.iframeRef}
          onLoad={this.handleIframeLoad}
          onError={this.handleIframeError}
          // 添加加载状态样式控制
          style={{
            ...iframeProps.style,
            display: iframeLoading ? 'none' : 'block'
          }}
        />
      </div>
    );

    switch (fileType.toLowerCase()) {
      case 'pdf':
        return (
          <div className="pdf-container">
            {fileUrl && (
              <React.Fragment>
                <div className="pdf-toolbar">
                  <div className="pdf-controls">
                    <button className="pdf-btn" onClick={this.prevPage} disabled={page <= 1}>
                      上一页
                    </button>
                    <span className="pdf-page-info">
                      {page} / {total}
                    </span>
                    <button className="pdf-btn" onClick={this.nextPage} disabled={page >= total}>
                      下一页
                    </button>
                  </div>
                </div>
                <div className="pdf-viewer-container">
                  <ReactPdf
                    width={'100%'}
                    style={{ width: '100%!important' }}
                    file={fileUrl}
                    onDocumentComplete={this.onDocumentComplete}
                    page={page}
                  />
                </div>
              </React.Fragment>
            )}
          </div>
        );

      case 'doc':
      case 'docx':
      case 'xls':
      case 'xlsx':
      case 'ppt':
      case 'pptx':
        return renderIframeWithLoading({
          src: `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`,
          className: 'office-frame',
          title: ''
        });

      // 图片、音视频等其他类型保持不变
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <img src={fileUrl} alt="Image Preview" className="image-preview" />;

      case 'mp4':
      case 'webm':
      case 'ogg':
        return (
          <video controls className="video-preview">
            <source src={fileUrl} type={`video/${fileType}`} />
            您的浏览器不支持视频播放
          </video>
        );

      case 'mp3':
      case 'wav':
        return (
          <audio controls className="audio-preview">
            <source src={fileUrl} type={`audio/${fileType}`} />
            您的浏览器不支持音频播放
          </audio>
        );

      default:
        return (
          <div className="unsupported-file">
            <p>不支持预览该类型的文件: {fileType}</p>
            <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="download-link">
              下载文件
            </a>
          </div>
        );
    }
  }

  render() {
    const { fileName } = this.state;

    return (
      <div className="file-preview-container">
        <div className="file-preview-content">{this.renderPreview()}</div>
      </div>
    );
  }
}

export default FilePreviewView;



// WEBPACK FOOTER //
// ./src/pages/FileSee/FileSeeView.js